module.exports = __webpack_public_path__ + "img/intro_no.855aee27.svg";